// extracted by mini-css-extract-plugin
module.exports = {"wrap":"be","heading":"ce"};